module.exports = __webpack_public_path__ + "static/media/buy_finish_service_rent_5.0ed6f7d6.jpg";